// extracted by mini-css-extract-plugin
export var eduGradient = "label-module--eduGradient--UxE+O";
export var label = "label-module--label--k9kha";
export var mainGradient = "label-module--mainGradient--fe9X9";
export var mainPrimary = "label-module--mainPrimary--Q+NcZ";
export var mainSecondary = "label-module--mainSecondary--KVz84";
export var sbShowMain = "label-module--sb-show-main--UMKQY";
export var totaraGradient = "label-module--totaraGradient--eIWZT";
export var workGradient = "label-module--workGradient--OFLcd";